export default {
      id: "eye-usage",
      viewBox: "285 415 23 12",
      url: __webpack_public_path__ + "app/svg/sprite.svg#eye",
      toString: function () {
        return this.url;
      }
    }